<template>
    <div class="col-md-12">
        <div class="card card-container">
            <Form @submit="setPassword" :validation-schema="schema">
                <div v-if="!successful">
                    <div class="form-group">
                        <label for="token">Token:</label>
                        <Field name="token" type="text" v-model="changeToken" class="form-control" />
                        <ErrorMessage name="token" class="error-feedback" />
                    </div>
                    
                    <div class="form-group">
                        <label for="password">New Password:</label>
                        <Field name="password" type="password" class="form-control" />
                        <ErrorMessage name="password" class="error-feedback" />
                    </div>

                    <div class="form-group">
                        <button class="btn btn-primary btn-block" :disabled="loading">
                            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                            Reset Password!
                        </button>
                    </div>
                </div>
            </Form>

            <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
                {{ message }}
            </div>
        </div>
    </div>
</template>

<script>
// import { useRoute } from 'vue-router';
// const route = useRoute();

import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../services/user.service";


export default {
    name: "PasswordReset",
    components: {
        Form,
        Field,
        ErrorMessage,
    },
    data() {
        
        const schema = yup.object().shape({
            token: yup
                .string()
                .required("Reset token is required!"),
            password: yup
                .string()
                .required("Password is required!")
                .min(6, "Must be at least 8 characters!")
                .max(40, "Must be maximum 40 characters!"),
        });

        return {
            successful: false,
            loading: false,
            message: "",
            changeToken:'',
            schema,
        };
    },

    methods: {
        setPassword(user) {
            this.message = "";
            this.successful = false;
            this.loading = true;

            UserService.setUserPassword(user).then(
                (res) => {
                    this.message = res.data['message'];
                    this.successful = true;
                    this.loading = false;
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.successful = false;
                    this.loading = false;
                }
            );
        },
    },

    mounted() {

        const params = (new URL(document.location)).searchParams;
        const resetToken = params.get('token');
        console.log(`resetToken: ${resetToken}`);
        this.changeToken = resetToken
        // let testRunData = {}

    }
};
</script>

<style scoped>
label {
    display: block;
    margin-top: 10px;
}

.card-container.card {
    max-width: 350px !important;
    padding: 40px 40px;
}

.card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 50px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
    width: 96px;
    height: 96px;
    margin: 0 auto 10px;
    display: block;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
}

.error-feedback {
    color: red;
}
</style>
